// i18n mínimo propio (sin vue-i18n: así el módulo embebido no arrastra dependencias que SherpaCRM
// no tenga). Idiomas: es (base), ca, en. `t('clave', {n: 3})` sustituye {n}.
import { ref } from 'vue';

export const locale = ref('es');

export function normalizeLang(lang) {
  const l = String(lang || '').toLowerCase().slice(0, 2);
  return ['es', 'ca', 'en'].includes(l) ? l : 'es';
}

const es = {
  'chk.title': 'Requisitos para ejecutarse',
  'chk.ready': 'Lista',
  'chk.missing': '{done}/{total} · faltan {n}',
  'chk.name': 'Nombre de la definición',
  'chk.entity': 'Entidad que se materializa',
  'chk.trigger': 'Cuándo se ejecuta (cron o intervalo válido)',
  'chk.sources': 'Al menos un formulario fuente activo',
  'chk.idAlias': 'Pregunta de la clave (id de origen o ID de la entidad) en cada formulario',
  'chk.origin': 'Origen en cada formulario con clave por origen (pregunta o texto fijo)',
  'chk.fields': 'Al menos un campo conectado',
  'chk.pendingIn': 'falta en: {forms}',
  'chk.server': 'Al guardar, el servidor avisa',
  'chk.runBlocked': 'Completa los requisitos para poder ejecutarla.',
  'app.section': 'Configuración',
  'app.title': 'Materializaciones',
  'app.intro': 'Cada definición vuelca las encuestas de uno o varios formularios a una entidad de Sherpa, deduplicando por origen + id de origen y fusionando cada campo según su regla.',
  'app.loading': 'Cargando…',
  'list.new': '+ Nueva materialización',
  'list.empty': 'Aún no hay materializaciones.',
  'list.edit': 'Editar',
  'list.run': 'Ejecutar ahora',
  'list.runQueued': 'Pedida: la recogerá el próximo tick del worker.',
  'list.noSources': 'sin formularios',
  'list.entity': 'Entidad que se materializa',
  'list.sources': 'Formularios fuente',
  'list.neverRun': 'Aún no se ha ejecutado.',
  'list.lastRunLbl': 'Última ejecución',
  'list.counts': 'total: {ok} ok · {errors} errores',
  'list.countsHint': 'Encuestas volcadas desde que existe la definición (ok) y las que siguen en error',
  'list.pending': '{n} encuestas por tratar',
  'list.pendingNone': 'nada por tratar',
  'list.pendingHint': 'Encuestas nuevas (y errores de antes del último cambio de la definición) que tratará la próxima ejecución',
  'list.summaryNone': 'No había encuestas nuevas ni errores que reintentar.',
  'list.summary': 'Procesó {pending} encuestas: {created} altas, {updated} actualizaciones, {unchanged} sin cambios, {errors} errores.',
  'list.fatal': 'Error',
  'state.enabled': 'activa',
  'state.disabled': 'desactivada',
  'state.ok': 'correcta',
  'state.partial': 'con errores',
  'state.error': 'fallida',
  'state.pendingRun': 'ejecución pedida',
  'state.running': 'en curso',
  'list.running': 'Ejecutándose',
  'list.preparing': 'Calculando las encuestas por tratar',
  'list.progress': '{done} de {total} encuestas ({pct} %)',
  'list.queued': 'En cola…',
  'trigger.once': 'Una vez',
  'trigger.cron': 'Cron',
  'trigger.interval': 'Intervalo',
  'trigger.manual': 'Manual',
  'trigger.every': 'cada {n} {unit}',
  'trigger.onlyManual': 'solo con «Ejecutar ahora»',
  'trigger.onceHint': 'una sola vez (hasta la primera pasada sin error de sistema)',
  'trigger.tickHint': 'El tick del flujo «Materializaciones» del worker marca la resolución mínima.',
  'unit.m': 'min',
  'unit.h': 'h',
  'unit.d': 'días',
  'ed.name': 'Nombre',
  'ed.enabled': 'Activa',
  'ed.disabled': 'Desactivada',
  'ed.when': 'Cuándo se ejecuta',
  'ed.run': 'Ejecutar ahora',
  'ed.save': 'Guardar',
  'ed.delete': 'Borrar',
  'ed.deleteConfirm': '¿Borrar la materialización «{name}»? Deja de ejecutarse; su linaje se conserva.',
  'ed.saved': 'Guardada.',
  'ed.close': 'Cerrar',
  'ed.unsaved': 'cambios sin guardar',
  'ed.runQueued': 'Ejecución pedida: la recogerá el próximo tick del worker.',
  'ed.saveFirst': 'Guarda primero los cambios.',
  'pal.filter': 'filtrar…',
  'pal.responses': '{n} encuestas',
  'node.missingForm': 'formulario no disponible',
  'ins.definition': 'Definición',
  'ins.description': 'Descripción',
  'ins.merge': 'Cómo se fusiona',
  'ins.idAlias': 'Pregunta con el id de origen',
  'ins.originAlias': 'Pregunta con el origen',
  'ins.chooseAlias': '— elige la pregunta —',
  'ins.originNone': '— sin pregunta —',
  'ins.keyHint': 'Origen + id de origen identifican el registro: dos encuestas con los mismos se fusionan en uno.',
  'ins.rootTaken': 'ya en «{name}»',
  'ins.originText': 'Texto fijo de origen',
  'ins.originTextPh': 'p. ej. REGCESS',
  'ins.originTextHint': 'Origen de todas las encuestas de este formulario.',
  'ins.originTextFallback': 'Se usa cuando la pregunta de origen viene vacía.',
  'ed.mapping': 'Entidad',
  'ed.noEntity': 'sin elegir',
  'ed.keyNoConnect': 'Ese campo es la clave: se rellena con el id de origen y el origen de cada formulario.',
  'list.keyFixed': 'texto fijo «{v}»',
  'list.keyFallback': 'si viene vacía, «{v}»',
  'list.keyMissing': 'pregunta sin elegir',
  'list.originMissing': 'sin pregunta ni texto fijo',
  'list.keyMissingHint': 'Así la definición no se puede ejecutar',
  'chip.keyId': 'ID ORIGEN',
  'chip.keyOrigin': 'ORIGEN',
  'chip.tables': 'TABLAS',
  'key.id': 'id de origen',
  'key.origin': 'origen',
  'ins.priority': 'Prioridad de la fuente',
  'ins.priorityHint': 'Manda en los campos con la regla «Por prioridad de formulario»: gana la de más arriba.',
  'ins.sourceEnabled': 'Fuente activa',
  'ins.removeSource': 'Quitar formulario',
  'ins.keyFields': 'Clave de deduplicación',
  'ins.responses': 'Encuestas cargadas: {n}',
  'merge.last': 'Último valor',
  'merge.last.d': 'La encuesta más reciente manda.',
  'merge.first': 'Primer valor',
  'merge.first.d': 'Solo se escribe si el campo está vacío.',
  'merge.priority': 'Por prioridad de formulario',
  'merge.priority.d': 'Manda la fuente de mayor prioridad (P1 > P2…).',
  'merge.concat': 'Concatenar',
  'merge.concat.d': 'Acumula los valores distintos: |a|b|.',
  'missing.keep': 'No tocar el campo',
  'missing.clear': 'Vaciar el campo',
  'chip.last': 'último valor',
  'chip.first': 'primer valor',
  'chip.priority': 'prioridad',
  'chip.concat': 'concatena',
  'cfg.profile': 'Cliente',
  'cfg.lang': 'Idioma',
  'cfg.test': 'Probar conexión',
  'cfg.tokenOk': 'bearer definido',
  'cfg.tokenMissing': 'sin bearer',
  'cfg.testOk': 'OK · {n} definiciones',
  'cfg.help': 'Perfiles en config/<cliente>/client.config.js (baseUrl + bearer de un usuario con rol administrador). Copia config/example.',
  'cfg.noProfiles': 'No hay perfiles: copia config/example a config/<cliente>/ y rellena baseUrl + token.',
  'list.and': ' y ',
  'list.more': '{list} y {k} más',
  'type.text': 'texto',
  'type.int': 'número entero',
  'type.dec': 'número decimal',
  'type.bool': 'sí/no',
  'type.date': 'fecha',
  'type.datetime': 'fecha y hora',
  'type.dateAny': 'fecha',
  'glyph.text': 'Aa',
  'glyph.int': '12',
  'glyph.dec': '1,5',
  'glyph.bool': 's/n',
  'glyph.date': 'd/m',
  'glyph.datetime': 'd/m h',
  'glyph.unsupported': '?',
  'sys.quest_id': 'el código del formulario de la encuesta (p. ej. {code})',
  'sys.response_id': 'el id de la encuesta',
  'sys.response_date': 'la fecha de la encuesta (aaaa-mm-dd hh:mm:ss)',
  'sysIn.quest_id': 'el código del formulario',
  'sysIn.response_id': 'el id de la encuesta',
  'sysIn.response_date': 'la fecha de la encuesta',
  'sysCap.quest_id': 'El código del formulario',
  'sysCap.response_id': 'El id de la encuesta',
  'sysCap.response_date': 'La fecha de la encuesta',
  'sysShort.quest_id': 'Formulario de la encuesta',
  'sysShort.response_id': 'Id de la encuesta',
  'sysShort.response_date': 'Fecha de la encuesta',
  'rc.none': 'Sin conexiones: la materialización no toca este campo.',
  'rc.noSources': 'No hay formularios fuente activos: ninguna encuesta llega a este campo.',
  'rc.src.sys': 'Guarda {sys}, que viene en todas las encuestas.',
  'rc.src.a1.f1': 'Toma el valor de la pregunta {q} de las encuestas de {form}.',
  'rc.src.a1.all': 'Toma el valor de la pregunta {q}, que traen los {n} formularios fuente.',
  'rc.src.a1.one': 'Toma el valor de la pregunta {q}, que de los {N} formularios fuente solo trae {form}.',
  'rc.src.a1.some': 'Toma el valor de la pregunta {q}, que traen {k} de los {N} formularios fuente: {forms}.',
  'rc.src.aN': 'Toma el valor de la primera de estas preguntas que la encuesta traiga informada: {chain}.',
  'rc.src.aN.all': 'Los {n} formularios fuente las traen todas.',
  'rc.src.partial': '{form} solo trae {list}.',
  'rc.src.silent1': '{form} no trae {what}: sus encuestas no aportan nada a este campo.',
  'rc.src.silentN': '{forms} no traen {what}: sus encuestas no aportan nada a este campo.',
  'rc.what.a1': 'la pregunta {q}',
  'rc.what.aN': 'ninguna de estas preguntas',
  'rc.src.dead': 'Ningún formulario fuente activo trae {what2}: el campo no recibirá valores.',
  'rc.what2.aN': 'estas preguntas',
  'rc.conv.text': 'Se guarda el texto de la respuesta, sin espacios al principio ni al final; en una pregunta de opciones, el código de la opción. Si trae varias respuestas, se guardan juntas: |a|b|.',
  'rc.conv.int': 'Se convierte a número entero: «12» o «12,0» valen; «12,5» o un texto dejan la encuesta en error. La coma y el punto son siempre decimales: «1.000» se guarda como 1.',
  'rc.conv.dec': 'Se convierte a número decimal, con coma o con punto («4,25» = «4.25»); un texto o un número con separador de miles («1.234,5») dejan la encuesta en error.',
  'rc.conv.bool': 'Se interpreta como sí/no: sí, si, s, yes, y, true o 1 es sí; no, n, false o 0 es no (da igual mayúsculas o minúsculas). Otra cosa deja la encuesta en error.',
  'rc.conv.date': 'Se convierte a fecha: dd/mm/aaaa o aaaa-mm-dd, con dos cifras en el día y el mes; si trae hora (hh:mm:ss), se descarta. Otro formato deja la encuesta en error.',
  'rc.conv.datetime': 'Se convierte a fecha y hora: dd/mm/aaaa hh:mm:ss, aaaa-mm-dd hh:mm:ss o aaaa-mm-ddThh:mm:ss; una fecha sola vale a las 00:00. Otro formato (por ejemplo, sin segundos) deja la encuesta en error.',
  'rc.conv.dateAny': 'Se convierte a fecha: dd/mm/aaaa o aaaa-mm-dd, con dos cifras en el día y el mes, y opcionalmente la hora con segundos (hh:mm:ss), que solo se guarda si el campo la admite. Otro formato deja la encuesta en error.',
  'rc.conv.unsupported': 'Este campo es de tipo {type}, que la materialización no sabe convertir: cada encuesta que traiga valor quedará en error.',
  'rc.conv.multi': 'Si la pregunta trae varias respuestas a la vez, la encuesta queda en error: un campo de {type} solo admite un valor.',
  'rc.conv.firstOnly': 'Si la primera pregunta informada no se puede convertir, la encuesta queda en error: no se prueba la siguiente.',
  'rc.conv.error': 'Una encuesta en error no escribe nada en el registro (ningún campo) y se vuelve a intentar con «Ejecutar ahora» o al volver a guardar la definición.',
  'rc.rule.last.f1': 'Último valor: cada encuesta con valor lo sobrescribe; queda el de la más reciente.',
  'rc.rule.last.fN': 'Último valor: cada encuesta con valor lo sobrescribe, sea del formulario que sea; queda el de la más reciente.',
  'rc.rule.first.f1': 'Primer valor: solo se escribe si el campo está vacío; queda el de la encuesta más antigua que lo trajo.',
  'rc.rule.first.fN': 'Primer valor: solo se escribe si el campo está vacío; queda el de la encuesta más antigua que lo trajo, sea del formulario que sea.',
  'rc.rule.first.existing': 'Si el registro ya tenía un valor (de otra carga o de una edición a mano), no se cambia.',
  'rc.rule.prio.fN': 'Por prioridad: manda el formulario de mayor prioridad ({ladder}). Una encuesta con valor lo sustituye si su formulario tiene igual o más prioridad que el que lo puso (a igual prioridad, gana la más reciente); una de menos prioridad solo lo escribe si el campo está vacío.',
  'rc.rule.prio.noEvidence': 'Se anota qué formulario puso cada valor. Si no consta (un valor de antes de usar esta regla, o puesto por otra vía), la primera encuesta con valor lo sustituye, sea cual sea su prioridad.',
  'rc.rule.prio.one': 'Por prioridad: solo {form} trae este campo, así que no hay a quién dar prioridad y funciona como «Último valor».',
  'rc.rule.prio.flat': 'Por prioridad: los {n} formularios que lo traen tienen la misma prioridad (P{p}), así que funciona como «Último valor». Dales prioridades distintas en Fuentes para que decida.',
  'rc.ladder.one': 'P{p} {form}',
  'rc.ladder.many': 'P{p} ({n} formularios)',
  'rc.rule.concat.f1': 'Concatenar: junta cada valor distinto en orden de llegada, sin repetir los idénticos (distingue mayúsculas y acentos), y siempre con el formato |a|b|, también con un solo valor: |a|.',
  'rc.rule.concat.fN': 'Concatenar: junta los valores distintos que llegan de los {n} formularios, en orden de llegada y sin repetir los idénticos (distingue mayúsculas y acentos), y siempre con el formato |a|b|, también con un solo valor: |a|.',
  'rc.rule.concat.existing': 'Un valor que el registro ya tuviera se conserva como primer elemento de la lista.',
  'rc.mini.asLast': 'como «Último valor»',
  'rc.miss.keep.a1': 'Si la encuesta no trae la pregunta {q} o viene en blanco, el campo se queda como estaba.',
  'rc.miss.keep.aN': 'Si la encuesta no trae ninguna de estas preguntas, o vienen en blanco, el campo se queda como estaba.',
  'rc.miss.clear.a1': 'Si la encuesta no trae la pregunta {q} o viene en blanco, el campo se vacía, sea cual sea la regla.',
  'rc.miss.clear.aN': 'Si la encuesta no trae ninguna de estas preguntas, o vienen en blanco, el campo se vacía, sea cual sea la regla.',
  'rc.miss.clear.last': 'Así el campo refleja siempre la última encuesta, también cuando llega sin valor.',
  'rc.miss.never': 'Como {sys} viene en todas las encuestas, nunca falta valor: «Si la encuesta no trae valor» no se aplica.',
  'rc.ext': 'Va en {table}, extensión 1:1 de {root}: ese registro solo se crea cuando una encuesta trae con valor algún campo suyo.',
  'rc.key.id': 'Lo fija la clave: es el id de origen de cada encuesta, que sale de la pregunta elegida en cada formulario fuente. No admite conexiones.',
  'rc.key.origin': 'Lo fija la clave: es el origen de cada encuesta, que sale de la pregunta de origen de su formulario o, si no la tiene o viene en blanco, de su texto fijo. No admite conexiones.',
  'rc.key.match': 'Dos encuestas con el mismo origen e id de origen (sin distinguir mayúsculas, acentos ni espacios finales) actualizan el mismo registro; si no existe, se crea.',
  'rc.key.spelling': 'El registro guarda el origen y el id tal como vienen en la última encuesta que lo actualiza.',
  'rc.key.error': 'Una encuesta sin id de origen, o sin origen, queda en error y no se vuelca.',
  'rc.key.q': 'pregunta {q}',
  'rc.key.text': 'texto fijo «{v}»',
  'rc.key.both': 'pregunta {q}; si viene en blanco, «{v}»',
  'rc.key.none': 'sin elegir: no se puede ejecutar',
  'w.dead': 'Ningún formulario fuente activo trae la pregunta {q}: esa conexión no aporta nada.',
  'w.clearSilent1': '{form} no trae {what} y el campo está en «Vaciar»: cada encuesta suya lo dejará vacío.',
  'w.clearSilentN': '{forms} no traen {what} y el campo está en «Vaciar»: cada encuesta suya lo dejará vacío.',
  'w.sysType': '{sysCap} es un texto que no cabe en un campo de {type}: cada encuesta quedará en error.',
  'w.sysTypeDate': 'La fecha de la encuesta no cabe en un campo de {type}: cada encuesta quedará en error.',
  'w.afterSys': '{sysCap} viene en todas las encuestas: las preguntas que van detrás ({rest}) no se usarán nunca.',
  'w.concatNotText': '«Concatenar» solo junta valores en campos de texto: en este campo de {type} funciona como «Último valor».',
  'w.firstClear': 'Con «Vaciar», una encuesta sin valor deja el campo vacío y la siguiente con valor lo vuelve a escribir: el primer valor deja de conservarse.',
  'w.prioClear': 'Con «Vaciar», una encuesta sin valor vacía el campo aunque su formulario tenga menos prioridad; después, cualquier formulario puede volver a rellenarlo.',
  'w.concatClear': 'Con «Vaciar», una encuesta sin valor borra todo lo acumulado.',
  'rc.note.title': 'Cómo se procesan las encuestas',
  'rc.note.order': 'En cada pasada, las encuestas pendientes de todos los formularios fuente activos se procesan juntas, de la más antigua a la más reciente (por fecha de la encuesta y, a igual fecha, por su id).',
  'rc.note.noop': 'Si el valor resultante es igual al que ya tenía, no se escribe.',
  'rc.note.lateRetry': 'Una encuesta que quedó en error y se reintenta más tarde se aplica después de las ya volcadas, aunque sea más antigua.',
  'rc.note.reactivate': 'Si el registro estaba borrado y le llega una encuesta, se reactiva.',
  'rc.note.past': 'Los cambios de reglas y conexiones solo se aplican a las encuestas que aún no se han volcado: las ya volcadas no se repasan.',
  'rc.one': '{rule} · {from} · {cover} · sin valor: {miss}',
  'rc.one.noCover': '{rule} · {from} · sin valor: {miss}',
  'rc.from1': 'de {q}',
  'rc.from2': 'de {q} › {q2}',
  'rc.fromMore': 'de {q} › {q2} y {k} más',
  'rc.coverAll': 'los {N} formularios',
  'rc.coverSome': '{k} de {N} formularios',
  'rc.missKeep': 'se conserva',
  'rc.missClear': 'se vacía',
  'rc.missNever': 'no se da',
  'chip.priorityLadder': 'prioridad {ladder}',
  'chip.clear': 'vacía sin valor',
  'chip.coverTitle': 'La traen {k} de los {N} formularios fuente activos',
  'rc.pf.title': 'Por formulario',
  'rc.pf.uses': 'usa {chain}',
  'rc.pf.silent': 'no trae ninguna',
  'rc.pf.keep': 'sin valor: conserva',
  'rc.pf.clear': 'sin valor: vacía',
  'rc.pf.never': 'siempre trae valor',
  'rc.pf.ignored': 'no lo toca',
  'rc.pf.clearsAlways': 'lo vacía en cada encuesta',
  'rc.pf.off': 'desactivado: no se procesa',
  'rc.pf.missing': 'formulario no activo: no se procesa',
  'rc.pf.leads': 'manda',
  'rc.pf.group': '{n} formularios',
  'rc.pf.show': 'ver',
  'ex.title': 'Ejemplo',
  'ex.hint': 'Encuestas inventadas, por orden de llegada: cambia valores o formularios para probar.',
  'ex.start': 'El registro empieza',
  'ex.startNew': 'nuevo (vacío)',
  'ex.startHad': 'con un valor de otra carga: {v}',
  'ex.result': 'Resultado: {v}',
  'ex.none': 'Ningún formulario trae estas preguntas: no hay ejemplo posible.',
  'ex.yes': 'sí',
  'ex.no': 'no',
  'ex.fill': 'lo rellena (estaba vacío)',
  'ex.set': 'lo sobrescribe',
  'ex.same': 'mismo valor: no se escribe',
  'ex.sameEv': 'mismo valor; ahora consta P{p}',
  'ex.ignoredFirst': 'ya tenía valor: no cambia',
  'ex.prioWins': 'P{p} tiene igual o más prioridad que P{q}: escribe',
  'ex.ignoredPrio': 'P{p} tiene menos prioridad que P{q}: no cambia',
  'ex.noEvidence': 'no consta quién lo puso: escribe',
  'ex.concat': 'se añade a la lista',
  'ex.concatDup': 'ya estaba en la lista: no cambia',
  'ex.keep': 'sin valor: se queda igual',
  'ex.clear': 'sin valor: se vacía',
  'ex.error': '«{raw}» no vale como {type}: la encuesta queda en error y no escribe nada',
  'ex.silent': '{form} no trae estas preguntas',
  'ex.matrix': '¿Y con otra regla?',
  'ex.matrixHint': 'Resultado final con cada regla; pulsa una casilla para aplicarla.',
  'ex.flag': 'esta combinación tiene un aviso',
  'conv.ok': 'vale',
  'conv.bad': 'deja la encuesta en error',
  'conv.thousands': 'el punto es decimal, no de miles',
  'fs.g.A': 'De dónde',
  'fs.g.C': 'Conversión',
  'fs.g.R': 'Regla',
  'fs.g.M': 'Sin valor',
  'fs.g.X': 'Registro',
  'fs.g.K': 'Clave',
  'chk.targets': 'Conexiones a campos válidos de la entidad',
  'when.chip': 'Cuándo: {v}',
  'when.once': 'una vez',
  'when.manual': 'manual',
  'when.cron': 'cron {v}',
  'def.change': 'Cambiar…',
  'def.changeConfirm': 'Cambiar de entidad quita las {n} conexiones y sus reglas. ¿Seguir?',
  'seg.last': 'Último',
  'seg.first': 'Primero',
  'seg.priority': 'Prioridad',
  'seg.concat': 'Concatenar',
  'seg.keep': 'No tocar',
  'seg.clear': 'Vaciar',
  'missing.keep.d': 'Si la encuesta no trae valor, se queda como estaba.',
  'missing.clear.d': 'Si la encuesta no trae valor, se borra, sea cual sea la regla.',
  'src.title': 'Fuentes',
  'src.add': '+ Añadir formulario',
  'src.addTitle': 'Añadir formulario fuente',
  'src.addOverlap': 'trae {k} de las {m} preguntas conectadas',
  'src.addNone': 'No quedan formularios activos por añadir.',
  'src.empty': 'Sin formularios fuente. Añade uno: sus preguntas aparecerán en el lienzo para conectarlas a los campos.',
  'src.coverage': '{k}/{m} conectadas',
  'src.coverageTitle': 'Trae {k} de las {m} preguntas conectadas en esta definición',
  'src.missing': 'formulario no activo: no se procesa',
  'src.off': 'desactivado: no se procesa',
  'src.filter': 'filtrar formularios…',
  'src.added': 'Formulario añadido: {form}.',
  'src.removed': 'Formulario quitado: {form}.',
  'key.fixed': '«{v}» (texto fijo)',
  'cv.aliases': 'Preguntas de las encuestas',
  'cv.aliasesSub': 'de los formularios fuente',
  'cv.key': 'Clave',
  'cv.keyVaries': 'varía por formulario ({n})',
  'cv.keyMissing': 'falta en {n}',
  'cv.count': '{n} conectados',
  'cv.freeAliases': '{n} preguntas sin conectar',
  'cv.freeFields': '{n} campos sin conectar',
  'cv.sysGroup': 'Datos de la encuesta',
  'cv.tagSys': 'dato',
  'cv.search': 'Buscar campo o pregunta',
  'cv.matches': '{n} coincidencias',
  'cv.onlyWarnings': 'Solo avisos · {n}',
  'cv.legend': 'Leyenda',
  'cv.emptyHint': 'Arrastra el punto ● de una pregunta hasta un campo para conectarlos, o pulsa un campo y elige su pregunta.',
  'cv.noSourcesHint': 'Añade un formulario fuente para ver sus preguntas.',
  'cv.peekHint': 'Clic para ver y editar cómo se calcula',
  'cv.deadTitle': 'Ningún formulario fuente activo trae esta pregunta',
  'cv.orderTitle': '{i}.ª pregunta: se usa si las anteriores no vienen informadas',
  'cv.aliasPeek': '{q} · {alias} · la traen {k} de {N} · conectada a {fields}',
  'cv.legacy': '{name}: ya no es extensión de {root}',
  'cv.legacyRemove': 'Quitar sus {n} conexiones',
  'zoom.fitWidth': 'Ajustar al ancho',
  'lg.on': 'A, B…: la letra del formulario en «Fuentes»; en color, la trae',
  'lg.off': 'en gris, no la trae',
  'lg.dis': 'tachada, formulario desactivado o no activo',
  'lg.bar': 'con más de 8 formularios: cuántos la traen',
  'lg.line': 'una línea por conexión',
  'lg.sys': 'discontinua: dato de la encuesta (viene en todas)',
  'lg.dead': 'punteada ámbar: ningún formulario activo la trae',
  'lg.order': '①②: orden de preferencia cuando un campo tiene varias preguntas',
  'lg.key': 'ID / ORIGEN: pregunta de la clave en algún formulario',
  'lg.status': 'punto ámbar: aviso · rojo: problema',
  'em.position': '{i}.ª de {n} preguntas de este campo',
  'em.only': 'única pregunta de este campo',
  'em.carried': 'La traen {k} de {N} formularios fuente',
  'em.global': 'La conexión vale para todos los formularios que traen esta pregunta.',
  'em.rule': 'Regla del campo',
  'em.ruleAll': 'afecta a sus {n} preguntas',
  'em.ruleOne': 'afecta al campo entero',
  'em.missing': 'Sin valor',
  'em.up': 'Usar antes',
  'em.down': 'Usar después',
  'em.first': 'Usar la primera',
  'em.replace': 'Cambiar pregunta…',
  'em.move': 'Mover a otro campo…',
  'em.moveTitle': 'Mover {q} a…',
  'em.copy': 'Conectar también a…',
  'em.fallback': 'Añadir otra pregunta detrás…',
  'em.forms': 'Ver qué formularios la traen',
  'em.formOn': 'la trae',
  'em.formOff': 'no la trae',
  'em.open': 'Abrir el campo',
  'em.remove': 'Quitar conexión',
  'em.back': 'Volver',
  'fs.prev': 'Campo anterior (Alt+RePág)',
  'fs.next': 'Campo siguiente (Alt+AvPág)',
  'fs.chain': 'Preguntas, en orden de preferencia',
  'fs.chainHint': 'Se usa la primera que la encuesta traiga informada.',
  'fs.add': '+ Añadir pregunta…',
  'fs.suggested': 'Sugeridas',
  'fs.carried': 'la traen {k} de {N}',
  'fs.up': 'Subir (Alt+↑)',
  'fs.down': 'Bajar (Alt+↓)',
  'fs.change': 'Cambiar pregunta (Intro)',
  'fs.remove': 'Quitar (Supr)',
  'fs.missing': 'Si la encuesta no trae valor',
  'fs.run': 'Así se ejecutará',
  'fs.column': 'columna {c}',
  'fs.warnCount': '{n} avisos',
  'fs.keyTitle': 'CLAVE · {what}',
  'fs.removeAll': 'Quitar sus conexiones',
  'fs.revert': 'Deshacer cambios del campo',
  'fs.done': 'Listo',
  'fs.editSource': 'Editar en Fuentes',
  'pk.search': 'buscar…',
  'pk.none': 'Sin resultados',
  'pk.questions': 'Preguntas',
  'pk.used': 'conectada a {fields}',
  'pk.here': 'ya conectada a este campo',
  'pk.key': 'lo fija la clave',
  'pk.current': 'campo actual',
  'ep.title': '¿Qué entidad vas a materializar?',
  'ep.hint': 'Se materializa con sus extensiones 1:1. Solo puede haber una materialización por entidad.',
  'ep.fields': '{n} campos',
  'ep.key': 'clave: {origin} + {id}',
  'ep.current': 'actual',
  'ep.allTaken': 'Todas las entidades materializables ya tienen su materialización.',
  'ep.cancel': 'Cancelar',
  'adv.title': 'Avisos · no impiden ejecutar',
  'adv.count': '{n} avisos',
  'adv.in': 'en: {list}',
  'adv.dead': 'Preguntas que ningún formulario activo trae',
  'adv.sysType': 'Datos de la encuesta en campos de otro tipo (cada encuesta dará error)',
  'adv.unsupported': 'Campos de un tipo que no se sabe convertir',
  'adv.clearSilent': '«Vaciar» en campos que algún formulario no trae',
  'adv.concatNotText': '«Concatenar» en campos que no son de texto',
  'adv.prioFlat': '«Por prioridad» con formularios de igual prioridad',
  'adv.afterSys': 'Preguntas detrás de un dato de la encuesta (no se usarán)',
  'adv.formMissing': 'Formularios fuente que ya no están activos (no se procesan)',
  'toast.undo': 'Deshacer',
  'toast.redo': 'Rehacer',
  'toast.open': 'Abrir el campo',
  'toast.view': 'Ver',
  'toast.connected': 'Conectada {q} → {field}.',
  'toast.removed': 'Conexión quitada.',
  'toast.removedAll': 'Quitadas {n} conexiones de {field}.',
  'toast.moved': 'Conexión movida a {field}.',
  'toast.copied': 'Conectada también a {field}.',
  'toast.exists': '{q} ya estaba conectada a {field}.',
  'toast.merged': '{q} ya estaba conectada a {field}: se ha quitado la repetida.',
  'toast.undone': 'Deshecho: {what}.',
  'toast.redone': 'Rehecho: {what}.',
  'toast.serverProblems': 'Guardada. El servidor avisa de {n} problemas.',
  'toast.entity': 'Entidad cambiada a {name}.',
  'hist.connect': 'conectar',
  'hist.remove': 'quitar conexión',
  'hist.removeAll': 'quitar conexiones del campo',
  'hist.reorder': 'cambiar el orden',
  'hist.replace': 'cambiar pregunta',
  'hist.move': 'mover conexión',
  'hist.copy': 'conectar también',
  'hist.fallback': 'añadir pregunta',
  'hist.rule': 'cambiar regla',
  'hist.addSource': 'añadir formulario',
  'hist.removeSource': 'quitar formulario',
  'hist.source': 'cambiar formulario fuente',
  'hist.entity': 'cambiar de entidad',
  'hist.revert': 'deshacer cambios del campo',
  'hist.legacy': 'quitar conexiones antiguas',
  'src.keyId': 'ID',
  'src.keyOrigin': 'ORIGEN',
  'when.every': 'cada',
  'em.removeKey': 'Supr',
  'fs.warnOne': '1 aviso',
  'fs.missKeep.d': 'Se queda como estaba.',
  'fs.missClear.d': 'Se borra, sea cual sea la regla.',
  'ex.formOf': 'Formulario de la encuesta del {day}',
  'ex.valueOf': 'Valor de la encuesta del {day}',
  'src.keyEntity': 'ID ENTIDAD',
  'ins.keyMode': 'Cómo se identifica el registro',
  'ins.keyMode.origin': 'Origen + id de origen',
  'ins.keyMode.entity': 'ID de la entidad',
  'ins.entityIdAlias': 'Pregunta con el ID de la entidad',
  'ins.entityKeyHint': 'La encuesta actualiza la entidad con ese ID. Si la pregunta viene vacía se crea una nueva; si trae un ID que no existe, la encuesta queda en error.',
  'rc.key.byEntity': 'no lo rellena: identifica la entidad por su ID ({q})',
  'rc.key.entityNote': 'Los formularios que identifican la entidad por su ID no tocan el origen ni el id de origen: una entidad nueva creada así los deja vacíos.',
  'src.badge': 'Formulario {code}: su letra marca en el lienzo las preguntas que trae',
  'src.prefix': 'PREFIJO',
  'src.prefixTitle': 'Prefijo común de los alias de este formulario: en el lienzo no se repite',
  'cv.orphans': '⚠ Quitar {n} conexiones sin formulario',
  'cv.orphansTitle': 'Preguntas que no están en ningún formulario de la definición (nunca traen valor): {list}',
  'hist.orphans': 'quitar conexiones sin formulario',
  'cv.aliasesOfForm': 'del formulario {code} · {name}',
  'cv.otherForms': 'Conectado desde otro formulario (selecciónalo en «Fuentes» para ver sus líneas)',
  'src.orderHint': 'El orden es la prioridad: arrastra las tarjetas por el asa para cambiarlo.',
  'src.dragTitle': 'Arrastra para cambiar la prioridad',
  'src.prioTitle': 'Prioridad {n} (posición en la lista)',
  'src.up': '↑ Subir',
  'src.down': '↓ Bajar',
  'hist.moveSource': 'cambiar la prioridad',
  'src.expand': 'Ver el detalle del formulario',
  'src.collapse': 'Ocultar el detalle',
};

const ca = {
  'chk.title': 'Requisits per executar-se',
  'chk.ready': 'Llesta',
  'chk.missing': '{done}/{total} · en falten {n}',
  'chk.name': 'Nom de la definició',
  'chk.entity': 'Entitat que es materialitza',
  'chk.trigger': 'Quan s\'executa (cron o interval vàlid)',
  'chk.sources': 'Almenys un formulari font actiu',
  'chk.idAlias': 'Pregunta de la clau (id d\'origen o ID de l\'entitat) a cada formulari',
  'chk.origin': 'Origen a cada formulari amb clau per origen (pregunta o text fix)',
  'chk.fields': 'Almenys un camp connectat',
  'chk.pendingIn': 'falta a: {forms}',
  'chk.server': 'En desar, el servidor avisa',
  'chk.runBlocked': 'Completa els requisits per poder-la executar.',
  'app.section': 'Configuració',
  'app.title': 'Materialitzacions',
  'app.intro': 'Cada definició bolca les enquestes d\'un o diversos formularis a una entitat de Sherpa, deduplicant per origen + id d\'origen i fusionant cada camp segons la seva regla.',
  'app.loading': 'Carregant…',
  'list.new': '+ Nova materialització',
  'list.empty': 'Encara no hi ha materialitzacions.',
  'list.edit': 'Editar',
  'list.run': 'Executar ara',
  'list.runQueued': 'Demanada: la recollirà el pròxim tick del worker.',
  'list.noSources': 'sense formularis',
  'list.entity': 'Entitat que es materialitza',
  'list.sources': 'Formularis font',
  'list.neverRun': 'Encara no s\'ha executat.',
  'list.lastRunLbl': 'Darrera execució',
  'list.counts': 'total: {ok} ok · {errors} errors',
  'list.countsHint': 'Enquestes bolcades des que existeix la definició (ok) i les que continuen en error',
  'list.pending': '{n} enquestes per tractar',
  'list.pendingNone': 'res per tractar',
  'list.pendingHint': 'Enquestes noves (i errors d\'abans del darrer canvi de la definició) que tractarà la propera execució',
  'list.summaryNone': 'No hi havia enquestes noves ni errors per reintentar.',
  'list.summary': 'Va processar {pending} enquestes: {created} altes, {updated} actualitzacions, {unchanged} sense canvis, {errors} errors.',
  'list.fatal': 'Error',
  'state.enabled': 'activa',
  'state.disabled': 'desactivada',
  'state.ok': 'correcta',
  'state.partial': 'amb errors',
  'state.error': 'fallida',
  'state.pendingRun': 'execució demanada',
  'state.running': 'en curs',
  'list.running': 'Executant-se',
  'list.preparing': 'Calculant les enquestes per tractar',
  'list.progress': '{done} de {total} enquestes ({pct} %)',
  'list.queued': 'En cua…',
  'trigger.once': 'Un cop',
  'trigger.interval': 'Interval',
  'trigger.every': 'cada {n} {unit}',
  'trigger.onlyManual': 'només amb «Executar ara»',
  'trigger.onceHint': 'un sol cop (fins a la primera passada sense error de sistema)',
  'trigger.tickHint': 'El tick del flux «Materialitzacions» del worker marca la resolució mínima.',
  'unit.d': 'dies',
  'ed.name': 'Nom',
  'ed.enabled': 'Activa',
  'ed.disabled': 'Desactivada',
  'ed.when': 'Quan s\'executa',
  'ed.run': 'Executar ara',
  'ed.save': 'Desar',
  'ed.delete': 'Esborrar',
  'ed.deleteConfirm': 'Esborrar la materialització «{name}»? Deixa d\'executar-se; el seu llinatge es conserva.',
  'ed.saved': 'Desada.',
  'ed.close': 'Tancar',
  'ed.unsaved': 'canvis sense desar',
  'ed.runQueued': 'Execució demanada: la recollirà el pròxim tick del worker.',
  'ed.saveFirst': 'Desa primer els canvis.',
  'pal.filter': 'filtrar…',
  'pal.responses': '{n} enquestes',
  'node.missingForm': 'formulari no disponible',
  'ins.definition': 'Definició',
  'ins.description': 'Descripció',
  'ins.merge': 'Com es fusiona',
  'ins.idAlias': 'Pregunta amb l\'id d\'origen',
  'ins.originAlias': 'Pregunta amb l\'origen',
  'ins.chooseAlias': '— tria la pregunta —',
  'ins.originNone': '— sense pregunta —',
  'ins.keyHint': 'Origen + id d\'origen identifiquen el registre: dues enquestes amb els mateixos es fusionen en un.',
  'ins.rootTaken': 'ja a «{name}»',
  'ins.originText': 'Text fix d\'origen',
  'ins.originTextPh': 'p. ex. REGCESS',
  'ins.originTextHint': 'Origen de totes les enquestes d\'aquest formulari.',
  'ins.originTextFallback': 'S\'usa quan la pregunta d\'origen ve buida.',
  'ed.mapping': 'Entitat',
  'ed.noEntity': 'sense triar',
  'ed.keyNoConnect': 'Aquest camp és la clau: s\'omple amb l\'id d\'origen i l\'origen de cada formulari.',
  'list.keyFixed': 'text fix «{v}»',
  'list.keyFallback': 'si ve buida, «{v}»',
  'list.keyMissing': 'pregunta sense triar',
  'list.originMissing': 'sense pregunta ni text fix',
  'list.keyMissingHint': 'Així la definició no es pot executar',
  'chip.keyId': 'ID ORIGEN',
  'chip.keyOrigin': 'ORIGEN',
  'chip.tables': 'TAULES',
  'key.id': 'id d\'origen',
  'key.origin': 'origen',
  'ins.priority': 'Prioritat de la font',
  'ins.priorityHint': 'Mana en els camps amb la regla «Per prioritat de formulari»: guanya la de més amunt.',
  'ins.sourceEnabled': 'Font activa',
  'ins.removeSource': 'Treure formulari',
  'ins.keyFields': 'Clau de deduplicació',
  'ins.responses': 'Enquestes carregades: {n}',
  'merge.last': 'Darrer valor',
  'merge.last.d': 'Mana l\'enquesta més recent.',
  'merge.first': 'Primer valor',
  'merge.first.d': 'Només s\'escriu si el camp és buit.',
  'merge.priority': 'Per prioritat de formulari',
  'merge.priority.d': 'Mana la font de més prioritat (P1 > P2…).',
  'merge.concat': 'Concatenar',
  'merge.concat.d': 'Acumula els valors diferents: |a|b|.',
  'missing.keep': 'No tocar el camp',
  'missing.clear': 'Buidar el camp',
  'chip.last': 'darrer valor',
  'cfg.profile': 'Client',
  'cfg.lang': 'Idioma',
  'cfg.test': 'Provar connexió',
  'cfg.tokenOk': 'bearer definit',
  'cfg.tokenMissing': 'sense bearer',
  'cfg.testOk': 'OK · {n} definicions',
  'cfg.help': 'Perfils a config/<client>/client.config.js (baseUrl + bearer d\'un usuari amb rol administrador). Copia config/example.',
  'cfg.noProfiles': 'No hi ha perfils: copia config/example a config/<client>/ i omple baseUrl + token.',
  'list.and': ' i ',
  'list.more': '{list} i {k} més',
  'type.text': 'text',
  'type.int': 'nombre enter',
  'type.dec': 'nombre decimal',
  'type.bool': 'sí/no',
  'type.date': 'data',
  'type.datetime': 'data i hora',
  'type.dateAny': 'data',
  'glyph.text': 'Aa',
  'glyph.int': '12',
  'glyph.dec': '1,5',
  'glyph.bool': 's/n',
  'glyph.date': 'd/m',
  'glyph.datetime': 'd/m h',
  'glyph.unsupported': '?',
  'sys.quest_id': 'el codi del formulari de l\'enquesta (p. ex. {code})',
  'sys.response_id': 'l\'id de l\'enquesta',
  'sys.response_date': 'la data de l\'enquesta (aaaa-mm-dd hh:mm:ss)',
  'sysIn.quest_id': 'el codi del formulari',
  'sysIn.response_id': 'l\'id de l\'enquesta',
  'sysIn.response_date': 'la data de l\'enquesta',
  'sysCap.quest_id': 'El codi del formulari',
  'sysCap.response_id': 'L\'id de l\'enquesta',
  'sysCap.response_date': 'La data de l\'enquesta',
  'sysShort.quest_id': 'Formulari de l\'enquesta',
  'sysShort.response_id': 'Id de l\'enquesta',
  'sysShort.response_date': 'Data de l\'enquesta',
  'rc.none': 'Sense connexions: la materialització no toca aquest camp.',
  'rc.noSources': 'No hi ha formularis font actius: cap enquesta no arriba a aquest camp.',
  'rc.src.sys': 'Desa {sys}, que arriba a totes les enquestes.',
  'rc.src.a1.f1': 'Pren el valor de la pregunta {q} de les enquestes de {form}.',
  'rc.src.a1.all': 'Pren el valor de la pregunta {q}, que porten els {n} formularis font.',
  'rc.src.a1.one': 'Pren el valor de la pregunta {q}, que dels {N} formularis font només porta {form}.',
  'rc.src.a1.some': 'Pren el valor de la pregunta {q}, que porten {k} dels {N} formularis font: {forms}.',
  'rc.src.aN': 'Pren el valor de la primera d\'aquestes preguntes que l\'enquesta porti informada: {chain}.',
  'rc.src.aN.all': 'Els {n} formularis font les porten totes.',
  'rc.src.partial': '{form} només porta {list}.',
  'rc.src.silent1': '{form} no porta {what}: les seves enquestes no aporten res a aquest camp.',
  'rc.src.silentN': '{forms} no porten {what}: les seves enquestes no aporten res a aquest camp.',
  'rc.what.a1': 'la pregunta {q}',
  'rc.what.aN': 'cap d\'aquestes preguntes',
  'rc.src.dead': 'Cap formulari font actiu no porta {what2}: el camp no rebrà valors.',
  'rc.what2.aN': 'aquestes preguntes',
  'rc.conv.text': 'Es desa el text de la resposta, sense espais al principi ni al final; en una pregunta d\'opcions, el codi de l\'opció. Si porta diverses respostes, es desen juntes: |a|b|.',
  'rc.conv.int': 'Es converteix a nombre enter: «12» o «12,0» valen; «12,5» o un text deixen l\'enquesta en error. La coma i el punt són sempre decimals: «1.000» es desa com a 1.',
  'rc.conv.dec': 'Es converteix a nombre decimal, amb coma o amb punt («4,25» = «4.25»); un text o un nombre amb separador de milers («1.234,5») deixen l\'enquesta en error.',
  'rc.conv.bool': 'S\'interpreta com a sí/no: sí, si, s, yes, y, true o 1 és sí; no, n, false o 0 és no (tant és majúscules com minúscules). Qualsevol altra cosa deixa l\'enquesta en error.',
  'rc.conv.date': 'Es converteix a data: dd/mm/aaaa o aaaa-mm-dd, amb dues xifres al dia i al mes; si porta hora (hh:mm:ss), es descarta. Un altre format deixa l\'enquesta en error.',
  'rc.conv.datetime': 'Es converteix a data i hora: dd/mm/aaaa hh:mm:ss, aaaa-mm-dd hh:mm:ss o aaaa-mm-ddThh:mm:ss; una data sola val a les 00:00. Un altre format (per exemple, sense segons) deixa l\'enquesta en error.',
  'rc.conv.dateAny': 'Es converteix a data: dd/mm/aaaa o aaaa-mm-dd, amb dues xifres al dia i al mes, i opcionalment l\'hora amb segons (hh:mm:ss), que només es desa si el camp l\'admet. Un altre format deixa l\'enquesta en error.',
  'rc.conv.unsupported': 'Aquest camp és de tipus {type}, que la materialització no sap convertir: cada enquesta que porti valor quedarà en error.',
  'rc.conv.multi': 'Si la pregunta porta diverses respostes alhora, l\'enquesta queda en error: un camp de {type} només admet un valor.',
  'rc.conv.firstOnly': 'Si la primera pregunta informada no es pot convertir, l\'enquesta queda en error: no es prova la següent.',
  'rc.conv.error': 'Una enquesta en error no escriu res al registre (cap camp) i es torna a intentar amb «Executar ara» o en tornar a desar la definició.',
  'rc.rule.last.f1': 'Darrer valor: cada enquesta amb valor el sobreescriu; queda el de la més recent.',
  'rc.rule.last.fN': 'Darrer valor: cada enquesta amb valor el sobreescriu, sigui del formulari que sigui; queda el de la més recent.',
  'rc.rule.first.f1': 'Primer valor: només s\'escriu si el camp és buit; queda el de l\'enquesta més antiga que el va portar.',
  'rc.rule.first.fN': 'Primer valor: només s\'escriu si el camp és buit; queda el de l\'enquesta més antiga que el va portar, sigui del formulari que sigui.',
  'rc.rule.first.existing': 'Si el registre ja tenia un valor (d\'una altra càrrega o d\'una edició a mà), no es canvia.',
  'rc.rule.prio.fN': 'Per prioritat: mana el formulari de més prioritat ({ladder}). Una enquesta amb valor el substitueix si el seu formulari té igual o més prioritat que el que el va posar (amb la mateixa prioritat, guanya la més recent); una de menys prioritat només l\'escriu si el camp és buit.',
  'rc.rule.prio.noEvidence': 'S\'anota quin formulari va posar cada valor. Si no consta (un valor d\'abans de fer servir aquesta regla, o posat per una altra via), la primera enquesta amb valor el substitueix, sigui quina sigui la seva prioritat.',
  'rc.rule.prio.one': 'Per prioritat: només {form} porta aquest camp, així que no hi ha a qui donar prioritat i funciona com a «Darrer valor».',
  'rc.rule.prio.flat': 'Per prioritat: els {n} formularis que el porten tenen la mateixa prioritat (P{p}), així que funciona com a «Darrer valor». Dona\'ls prioritats diferents a Fonts perquè decideixi.',
  'rc.ladder.one': 'P{p} {form}',
  'rc.ladder.many': 'P{p} ({n} formularis)',
  'rc.rule.concat.f1': 'Concatenar: ajunta cada valor diferent en ordre d\'arribada, sense repetir els idèntics (distingeix majúscules i accents), i sempre amb el format |a|b|, també amb un sol valor: |a|.',
  'rc.rule.concat.fN': 'Concatenar: ajunta els valors diferents que arriben dels {n} formularis, en ordre d\'arribada i sense repetir els idèntics (distingeix majúscules i accents), i sempre amb el format |a|b|, també amb un sol valor: |a|.',
  'rc.rule.concat.existing': 'Un valor que el registre ja tingués es conserva com a primer element de la llista.',
  'rc.mini.asLast': 'com a «Darrer valor»',
  'rc.miss.keep.a1': 'Si l\'enquesta no porta la pregunta {q} o arriba en blanc, el camp es queda com estava.',
  'rc.miss.keep.aN': 'Si l\'enquesta no porta cap d\'aquestes preguntes, o arriben en blanc, el camp es queda com estava.',
  'rc.miss.clear.a1': 'Si l\'enquesta no porta la pregunta {q} o arriba en blanc, el camp es buida, sigui quina sigui la regla.',
  'rc.miss.clear.aN': 'Si l\'enquesta no porta cap d\'aquestes preguntes, o arriben en blanc, el camp es buida, sigui quina sigui la regla.',
  'rc.miss.clear.last': 'Així el camp reflecteix sempre la darrera enquesta, també quan arriba sense valor.',
  'rc.miss.never': 'Com que {sys} arriba a totes les enquestes, mai no falta valor: «Si l\'enquesta no porta valor» no s\'aplica.',
  'rc.ext': 'Va a {table}, extensió 1:1 de {root}: aquest registre només es crea quan una enquesta porta amb valor algun camp seu.',
  'rc.key.id': 'El fixa la clau: és l\'id d\'origen de cada enquesta, que surt de la pregunta triada a cada formulari font. No admet connexions.',
  'rc.key.origin': 'El fixa la clau: és l\'origen de cada enquesta, que surt de la pregunta d\'origen del seu formulari o, si no en té o arriba en blanc, del seu text fix. No admet connexions.',
  'rc.key.match': 'Dues enquestes amb el mateix origen i id d\'origen (sense distingir majúscules, accents ni espais finals) actualitzen el mateix registre; si no existeix, es crea.',
  'rc.key.spelling': 'El registre desa l\'origen i l\'id tal com arriben a la darrera enquesta que l\'actualitza.',
  'rc.key.error': 'Una enquesta sense id d\'origen, o sense origen, queda en error i no es bolca.',
  'rc.key.q': 'pregunta {q}',
  'rc.key.text': 'text fix «{v}»',
  'rc.key.both': 'pregunta {q}; si arriba en blanc, «{v}»',
  'rc.key.none': 'sense triar: no es pot executar',
  'w.dead': 'Cap formulari font actiu no porta la pregunta {q}: aquesta connexió no aporta res.',
  'w.clearSilent1': '{form} no porta {what} i el camp és a «Buidar»: cada enquesta seva el deixarà buit.',
  'w.clearSilentN': '{forms} no porten {what} i el camp és a «Buidar»: cada enquesta seva el deixarà buit.',
  'w.sysType': '{sysCap} és un text que no hi cap en un camp de {type}: cada enquesta quedarà en error.',
  'w.sysTypeDate': 'La data de l\'enquesta no hi cap en un camp de {type}: cada enquesta quedarà en error.',
  'w.afterSys': '{sysCap} arriba a totes les enquestes: les preguntes que van darrere ({rest}) no es faran servir mai.',
  'w.concatNotText': '«Concatenar» només ajunta valors en camps de text: en aquest camp de {type} funciona com a «Darrer valor».',
  'w.firstClear': 'Amb «Buidar», una enquesta sense valor deixa el camp buit i la següent amb valor el torna a escriure: el primer valor deixa de conservar-se.',
  'w.prioClear': 'Amb «Buidar», una enquesta sense valor buida el camp encara que el seu formulari tingui menys prioritat; després, qualsevol formulari el pot tornar a omplir.',
  'w.concatClear': 'Amb «Buidar», una enquesta sense valor esborra tot el que s\'ha acumulat.',
  'rc.note.title': 'Com es processen les enquestes',
  'rc.note.order': 'A cada passada, les enquestes pendents de tots els formularis font actius es processen juntes, de la més antiga a la més recent (per data de l\'enquesta i, amb la mateixa data, pel seu id).',
  'rc.note.noop': 'Si el valor resultant és igual al que ja tenia, no s\'escriu.',
  'rc.note.lateRetry': 'Una enquesta que va quedar en error i es reintenta més tard s\'aplica després de les ja bolcades, encara que sigui més antiga.',
  'rc.note.reactivate': 'Si el registre estava esborrat i li arriba una enquesta, es reactiva.',
  'rc.note.past': 'Els canvis de regles i connexions només s\'apliquen a les enquestes que encara no s\'han bolcat: les ja bolcades no es repassen.',
  'rc.one': '{rule} · {from} · {cover} · sense valor: {miss}',
  'rc.one.noCover': '{rule} · {from} · sense valor: {miss}',
  'rc.from1': 'de {q}',
  'rc.from2': 'de {q} › {q2}',
  'rc.fromMore': 'de {q} › {q2} i {k} més',
  'rc.coverAll': 'els {N} formularis',
  'rc.coverSome': '{k} de {N} formularis',
  'rc.missKeep': 'es conserva',
  'rc.missClear': 'es buida',
  'rc.missNever': 'no es dona',
  'chip.first': 'primer valor',
  'chip.priority': 'prioritat',
  'chip.priorityLadder': 'prioritat {ladder}',
  'chip.concat': 'concatena',
  'chip.clear': 'buida sense valor',
  'chip.coverTitle': 'La porten {k} dels {N} formularis font actius',
  'rc.pf.title': 'Per formulari',
  'rc.pf.uses': 'fa servir {chain}',
  'rc.pf.silent': 'no en porta cap',
  'rc.pf.keep': 'sense valor: conserva',
  'rc.pf.clear': 'sense valor: buida',
  'rc.pf.never': 'sempre porta valor',
  'rc.pf.ignored': 'no el toca',
  'rc.pf.clearsAlways': 'el buida a cada enquesta',
  'rc.pf.off': 'desactivat: no es processa',
  'rc.pf.missing': 'formulari no actiu: no es processa',
  'rc.pf.leads': 'mana',
  'rc.pf.group': '{n} formularis',
  'rc.pf.show': 'veure',
  'ex.title': 'Exemple',
  'ex.hint': 'Enquestes inventades, per ordre d\'arribada: canvia valors o formularis per provar.',
  'ex.start': 'El registre comença',
  'ex.startNew': 'nou (buit)',
  'ex.startHad': 'amb un valor d\'una altra càrrega: {v}',
  'ex.result': 'Resultat: {v}',
  'ex.none': 'Cap formulari no porta aquestes preguntes: no hi ha exemple possible.',
  'ex.yes': 'sí',
  'ex.no': 'no',
  'ex.fill': 'l\'omple (era buit)',
  'ex.set': 'el sobreescriu',
  'ex.same': 'mateix valor: no s\'escriu',
  'ex.sameEv': 'mateix valor; ara consta P{p}',
  'ex.ignoredFirst': 'ja tenia valor: no canvia',
  'ex.prioWins': 'P{p} té igual o més prioritat que P{q}: escriu',
  'ex.ignoredPrio': 'P{p} té menys prioritat que P{q}: no canvia',
  'ex.noEvidence': 'no consta qui el va posar: escriu',
  'ex.concat': 's\'afegeix a la llista',
  'ex.concatDup': 'ja era a la llista: no canvia',
  'ex.keep': 'sense valor: es queda igual',
  'ex.clear': 'sense valor: es buida',
  'ex.error': '«{raw}» no val com a {type}: l\'enquesta queda en error i no escriu res',
  'ex.silent': '{form} no porta aquestes preguntes',
  'ex.matrix': 'I amb una altra regla?',
  'ex.matrixHint': 'Resultat final amb cada regla; prem una casella per aplicar-la.',
  'ex.flag': 'aquesta combinació té un avís',
  'conv.ok': 'val',
  'conv.bad': 'deixa l\'enquesta en error',
  'conv.thousands': 'el punt és decimal, no de milers',
  'fs.g.A': 'D\'on',
  'fs.g.C': 'Conversió',
  'fs.g.R': 'Regla',
  'fs.g.M': 'Sense valor',
  'fs.g.X': 'Registre',
  'fs.g.K': 'Clau',
  'chk.targets': 'Connexions a camps vàlids de l\'entitat',
  'when.chip': 'Quan: {v}',
  'when.once': 'un cop',
  'when.manual': 'manual',
  'when.cron': 'cron {v}',
  'def.change': 'Canviar…',
  'def.changeConfirm': 'Canviar d\'entitat treu les {n} connexions i les seves regles. Vols continuar?',
  'seg.last': 'Darrer',
  'seg.first': 'Primer',
  'seg.priority': 'Prioritat',
  'seg.concat': 'Concatenar',
  'seg.keep': 'No tocar',
  'seg.clear': 'Buidar',
  'missing.keep.d': 'Si l\'enquesta no porta valor, es queda com estava.',
  'missing.clear.d': 'Si l\'enquesta no porta valor, s\'esborra, sigui quina sigui la regla.',
  'src.title': 'Fonts',
  'src.add': '+ Afegir formulari',
  'src.addTitle': 'Afegir formulari font',
  'src.addOverlap': 'porta {k} de les {m} preguntes connectades',
  'src.addNone': 'No queden formularis actius per afegir.',
  'src.empty': 'Sense formularis font. Afegeix-ne un: les seves preguntes apareixeran al llenç per connectar-les als camps.',
  'src.coverage': '{k}/{m} connectades',
  'src.coverageTitle': 'Porta {k} de les {m} preguntes connectades en aquesta definició',
  'src.missing': 'formulari no actiu: no es processa',
  'src.off': 'desactivat: no es processa',
  'src.filter': 'filtrar formularis…',
  'src.added': 'Formulari afegit: {form}.',
  'src.removed': 'Formulari tret: {form}.',
  'key.fixed': '«{v}» (text fix)',
  'cv.aliases': 'Preguntes de les enquestes',
  'cv.aliasesSub': 'dels formularis font',
  'cv.key': 'Clau',
  'cv.keyVaries': 'varia per formulari ({n})',
  'cv.keyMissing': 'falta a {n}',
  'cv.count': '{n} connectats',
  'cv.freeAliases': '{n} preguntes sense connectar',
  'cv.freeFields': '{n} camps sense connectar',
  'cv.sysGroup': 'Dades de l\'enquesta',
  'cv.tagSys': 'dada',
  'cv.search': 'Cercar camp o pregunta',
  'cv.matches': '{n} coincidències',
  'cv.onlyWarnings': 'Només avisos · {n}',
  'cv.legend': 'Llegenda',
  'cv.emptyHint': 'Arrossega el punt ● d\'una pregunta fins a un camp per connectar-los, o prem un camp i tria\'n la pregunta.',
  'cv.noSourcesHint': 'Afegeix un formulari font per veure\'n les preguntes.',
  'cv.peekHint': 'Clic per veure i editar com es calcula',
  'cv.deadTitle': 'Cap formulari font actiu no porta aquesta pregunta',
  'cv.orderTitle': '{i}a pregunta: es fa servir si les anteriors no arriben informades',
  'cv.aliasPeek': '{q} · {alias} · la porten {k} de {N} · connectada a {fields}',
  'cv.legacy': '{name}: ja no és extensió de {root}',
  'cv.legacyRemove': 'Treure\'n les {n} connexions',
  'zoom.fitWidth': 'Ajustar a l\'amplada',
  'lg.on': 'A, B…: la lletra del formulari a «Fonts»; en color, la porta',
  'lg.off': 'en gris, no la porta',
  'lg.dis': 'ratllada, formulari desactivat o no actiu',
  'lg.bar': 'amb més de 8 formularis: quants la porten',
  'lg.line': 'una línia per connexió',
  'lg.sys': 'discontínua: dada de l\'enquesta (arriba a totes)',
  'lg.dead': 'puntejada àmbar: cap formulari actiu no la porta',
  'lg.order': '①②: ordre de preferència quan un camp té diverses preguntes',
  'lg.key': 'ID / ORIGEN: pregunta de la clau en algun formulari',
  'lg.status': 'punt àmbar: avís · vermell: problema',
  'em.position': '{i}a de {n} preguntes d\'aquest camp',
  'em.only': 'única pregunta d\'aquest camp',
  'em.carried': 'La porten {k} de {N} formularis font',
  'em.global': 'La connexió val per a tots els formularis que porten aquesta pregunta.',
  'em.rule': 'Regla del camp',
  'em.ruleAll': 'afecta les seves {n} preguntes',
  'em.ruleOne': 'afecta tot el camp',
  'em.missing': 'Sense valor',
  'em.up': 'Fer servir abans',
  'em.down': 'Fer servir després',
  'em.first': 'Fer-la servir primer',
  'em.replace': 'Canviar pregunta…',
  'em.move': 'Moure a un altre camp…',
  'em.moveTitle': 'Moure {q} a…',
  'em.copy': 'Connectar també a…',
  'em.fallback': 'Afegir una altra pregunta darrere…',
  'em.forms': 'Veure quins formularis la porten',
  'em.formOn': 'la porta',
  'em.formOff': 'no la porta',
  'em.open': 'Obrir el camp',
  'em.remove': 'Treure connexió',
  'em.back': 'Tornar',
  'fs.prev': 'Camp anterior (Alt+RePàg)',
  'fs.next': 'Camp següent (Alt+AvPàg)',
  'fs.chain': 'Preguntes, en ordre de preferència',
  'fs.chainHint': 'Es fa servir la primera que l\'enquesta porti informada.',
  'fs.add': '+ Afegir pregunta…',
  'fs.suggested': 'Suggerides',
  'fs.carried': 'la porten {k} de {N}',
  'fs.up': 'Pujar (Alt+↑)',
  'fs.down': 'Baixar (Alt+↓)',
  'fs.change': 'Canviar pregunta (Retorn)',
  'fs.remove': 'Treure (Supr)',
  'fs.missing': 'Si l\'enquesta no porta valor',
  'fs.run': 'Així s\'executarà',
  'fs.column': 'columna {c}',
  'fs.warnCount': '{n} avisos',
  'fs.keyTitle': 'CLAU · {what}',
  'fs.removeAll': 'Treure\'n les connexions',
  'fs.revert': 'Desfer canvis del camp',
  'fs.done': 'Fet',
  'fs.editSource': 'Editar a Fonts',
  'pk.search': 'cercar…',
  'pk.none': 'Sense resultats',
  'pk.questions': 'Preguntes',
  'pk.used': 'connectada a {fields}',
  'pk.here': 'ja connectada a aquest camp',
  'pk.key': 'el fixa la clau',
  'pk.current': 'camp actual',
  'ep.title': 'Quina entitat vols materialitzar?',
  'ep.hint': 'Es materialitza amb les seves extensions 1:1. Només hi pot haver una materialització per entitat.',
  'ep.fields': '{n} camps',
  'ep.key': 'clau: {origin} + {id}',
  'ep.current': 'actual',
  'ep.allTaken': 'Totes les entitats materialitzables ja tenen la seva materialització.',
  'ep.cancel': 'Cancel·lar',
  'adv.title': 'Avisos · no impedeixen executar',
  'adv.count': '{n} avisos',
  'adv.in': 'a: {list}',
  'adv.dead': 'Preguntes que cap formulari actiu no porta',
  'adv.sysType': 'Dades de l\'enquesta en camps d\'un altre tipus (cada enquesta donarà error)',
  'adv.unsupported': 'Camps d\'un tipus que no se sap convertir',
  'adv.clearSilent': '«Buidar» en camps que algun formulari no porta',
  'adv.concatNotText': '«Concatenar» en camps que no són de text',
  'adv.prioFlat': '«Per prioritat» amb formularis d\'igual prioritat',
  'adv.afterSys': 'Preguntes darrere d\'una dada de l\'enquesta (no es faran servir)',
  'adv.formMissing': 'Formularis font que ja no són actius (no es processen)',
  'toast.undo': 'Desfer',
  'toast.redo': 'Refer',
  'toast.open': 'Obrir el camp',
  'toast.view': 'Veure',
  'toast.connected': 'Connectada {q} → {field}.',
  'toast.removed': 'Connexió treta.',
  'toast.removedAll': 'Tretes {n} connexions de {field}.',
  'toast.moved': 'Connexió moguda a {field}.',
  'toast.copied': 'Connectada també a {field}.',
  'toast.exists': '{q} ja estava connectada a {field}.',
  'toast.merged': '{q} ja estava connectada a {field}: s\'ha tret la repetida.',
  'toast.undone': 'Desfet: {what}.',
  'toast.redone': 'Refet: {what}.',
  'toast.serverProblems': 'Desada. El servidor avisa de {n} problemes.',
  'toast.entity': 'Entitat canviada a {name}.',
  'hist.connect': 'connectar',
  'hist.remove': 'treure connexió',
  'hist.removeAll': 'treure connexions del camp',
  'hist.reorder': 'canviar l\'ordre',
  'hist.replace': 'canviar pregunta',
  'hist.move': 'moure connexió',
  'hist.copy': 'connectar també',
  'hist.fallback': 'afegir pregunta',
  'hist.rule': 'canviar regla',
  'hist.addSource': 'afegir formulari',
  'hist.removeSource': 'treure formulari',
  'hist.source': 'canviar formulari font',
  'hist.entity': 'canviar d\'entitat',
  'hist.revert': 'desfer canvis del camp',
  'hist.legacy': 'treure connexions antigues',
  'src.keyId': 'ID',
  'src.keyOrigin': 'ORIGEN',
  'when.every': 'cada',
  'em.removeKey': 'Supr',
  'fs.warnOne': '1 avís',
  'fs.missKeep.d': 'Es queda com estava.',
  'fs.missClear.d': 'S\'esborra, sigui quina sigui la regla.',
  'ex.formOf': 'Formulari de l\'enquesta del {day}',
  'ex.valueOf': 'Valor de l\'enquesta del {day}',
  'src.keyEntity': 'ID ENTITAT',
  'ins.keyMode': 'Com s\'identifica el registre',
  'ins.keyMode.origin': 'Origen + id d\'origen',
  'ins.keyMode.entity': 'ID de l\'entitat',
  'ins.entityIdAlias': 'Pregunta amb l\'ID de l\'entitat',
  'ins.entityKeyHint': 'L\'enquesta actualitza l\'entitat amb aquest ID. Si la pregunta arriba buida se\'n crea una de nova; si porta un ID que no existeix, l\'enquesta queda en error.',
  'rc.key.byEntity': 'no l\'omple: identifica l\'entitat pel seu ID ({q})',
  'rc.key.entityNote': 'Els formularis que identifiquen l\'entitat pel seu ID no toquen l\'origen ni l\'id d\'origen: una entitat nova creada així els deixa buits.',
  'src.badge': 'Formulari {code}: la seva lletra marca al llenç les preguntes que porta',
  'src.prefix': 'PREFIX',
  'src.prefixTitle': 'Prefix comú dels àlies d\'aquest formulari: al llenç no es repeteix',
  'cv.orphans': '⚠ Treure {n} connexions sense formulari',
  'cv.orphansTitle': 'Preguntes que no són a cap formulari de la definició (mai no porten valor): {list}',
  'hist.orphans': 'treure connexions sense formulari',
  'cv.aliasesOfForm': 'del formulari {code} · {name}',
  'cv.otherForms': 'Connectat des d\'un altre formulari (selecciona\'l a «Fonts» per veure\'n les línies)',
  'src.orderHint': 'L\'ordre és la prioritat: arrossega les targetes per la nansa per canviar-lo.',
  'src.dragTitle': 'Arrossega per canviar la prioritat',
  'src.prioTitle': 'Prioritat {n} (posició a la llista)',
  'src.up': '↑ Pujar',
  'src.down': '↓ Baixar',
  'hist.moveSource': 'canviar la prioritat',
  'src.expand': 'Veure el detall del formulari',
  'src.collapse': 'Amagar el detall',
};

const en = {
  'chk.title': 'Requirements to run',
  'chk.ready': 'Ready',
  'chk.missing': '{done}/{total} · {n} missing',
  'chk.name': 'Definition name',
  'chk.entity': 'Entity to materialize',
  'chk.trigger': 'When it runs (valid cron or interval)',
  'chk.sources': 'At least one active source form',
  'chk.idAlias': 'Key question (source id or entity ID) in every form',
  'chk.origin': 'Origin in every origin-keyed form (question or fixed text)',
  'chk.fields': 'At least one connected field',
  'chk.pendingIn': 'missing in: {forms}',
  'chk.server': 'On save, the server reports',
  'chk.runBlocked': 'Complete the requirements to run it.',
  'app.section': 'Configuration',
  'app.title': 'Materializations',
  'app.intro': 'Each definition loads the submissions of one or more forms into a Sherpa entity, deduplicating by origin + source id and merging each field by its rule.',
  'app.loading': 'Loading…',
  'list.new': '+ New materialization',
  'list.empty': 'No materializations yet.',
  'list.edit': 'Edit',
  'list.run': 'Run now',
  'list.runQueued': 'Requested: the next worker tick will pick it up.',
  'list.noSources': 'no forms',
  'list.entity': 'Entity being materialized',
  'list.sources': 'Source forms',
  'list.neverRun': 'Not run yet.',
  'list.lastRunLbl': 'Last run',
  'list.counts': 'total: {ok} ok · {errors} errors',
  'list.countsHint': 'Submissions loaded since the definition exists (ok) and those still in error',
  'list.pending': '{n} submissions to process',
  'list.pendingNone': 'nothing to process',
  'list.pendingHint': 'New submissions (and errors from before the last change to the definition) that the next run will process',
  'list.summaryNone': 'There were no new submissions or errors to retry.',
  'list.summary': 'Processed {pending} submissions: {created} created, {updated} updated, {unchanged} unchanged, {errors} errors.',
  'list.fatal': 'Error',
  'state.enabled': 'enabled',
  'state.disabled': 'disabled',
  'state.ok': 'ok',
  'state.partial': 'with errors',
  'state.error': 'failed',
  'state.pendingRun': 'run requested',
  'state.running': 'running',
  'list.running': 'Running',
  'list.preparing': 'Working out the submissions to process',
  'list.progress': '{done} of {total} submissions ({pct}%)',
  'list.queued': 'Queued…',
  'trigger.once': 'Once',
  'trigger.interval': 'Interval',
  'trigger.every': 'every {n} {unit}',
  'trigger.onlyManual': 'only with «Run now»',
  'trigger.onceHint': 'a single time (until the first run without a system error)',
  'trigger.tickHint': 'The worker «Materializations» flow tick sets the minimum resolution.',
  'unit.d': 'days',
  'ed.name': 'Name',
  'ed.enabled': 'Enabled',
  'ed.disabled': 'Disabled',
  'ed.when': 'When it runs',
  'ed.run': 'Run now',
  'ed.save': 'Save',
  'ed.delete': 'Delete',
  'ed.deleteConfirm': 'Delete the materialization «{name}»? It stops running; its lineage is kept.',
  'ed.saved': 'Saved.',
  'ed.close': 'Close',
  'ed.unsaved': 'unsaved changes',
  'ed.runQueued': 'Run requested: the next worker tick will pick it up.',
  'ed.saveFirst': 'Save your changes first.',
  'pal.filter': 'filter…',
  'pal.responses': '{n} submissions',
  'node.missingForm': 'form not available',
  'ins.definition': 'Definition',
  'ins.description': 'Description',
  'ins.merge': 'How it merges',
  'ins.idAlias': 'Question with the source id',
  'ins.originAlias': 'Question with the origin',
  'ins.chooseAlias': '— choose the question —',
  'ins.originNone': '— no question —',
  'ins.keyHint': 'Origin + source id identify the record: two submissions with the same ones merge into one.',
  'ins.rootTaken': 'already in «{name}»',
  'ins.originText': 'Fixed origin text',
  'ins.originTextPh': 'e.g. REGCESS',
  'ins.originTextHint': 'Origin of every submission of this form.',
  'ins.originTextFallback': 'Used when the origin question comes empty.',
  'ed.mapping': 'Entity',
  'ed.noEntity': 'not chosen',
  'ed.keyNoConnect': 'That field is the key: it is filled with each form\'s source id and origin.',
  'list.keyFixed': 'fixed text «{v}»',
  'list.keyFallback': 'if empty, «{v}»',
  'list.keyMissing': 'question not chosen',
  'list.originMissing': 'no question or fixed text',
  'list.keyMissingHint': 'The definition cannot run like this',
  'chip.keyId': 'SOURCE ID',
  'chip.keyOrigin': 'ORIGIN',
  'chip.tables': 'TABLES',
  'key.id': 'source id',
  'key.origin': 'origin',
  'ins.priority': 'Source priority',
  'ins.priorityHint': 'Wins on fields with the «By form priority» rule: the higher one wins.',
  'ins.sourceEnabled': 'Source enabled',
  'ins.removeSource': 'Remove form',
  'ins.keyFields': 'Deduplication key',
  'ins.responses': 'Loaded submissions: {n}',
  'merge.last': 'Last value',
  'merge.last.d': 'The most recent submission wins.',
  'merge.first': 'First value',
  'merge.first.d': 'Only written if the field is empty.',
  'merge.priority': 'By form priority',
  'merge.priority.d': 'The highest-priority source wins (P1 > P2…).',
  'merge.concat': 'Concatenate',
  'merge.concat.d': 'Accumulates distinct values: |a|b|.',
  'missing.keep': 'Leave the field',
  'missing.clear': 'Clear the field',
  'chip.last': 'last value',
  'chip.first': 'first value',
  'cfg.profile': 'Client',
  'cfg.lang': 'Language',
  'cfg.test': 'Test connection',
  'cfg.tokenOk': 'bearer set',
  'cfg.tokenMissing': 'no bearer',
  'cfg.testOk': 'OK · {n} definitions',
  'cfg.help': 'Profiles in config/<client>/client.config.js (baseUrl + bearer of an administrator user). Copy config/example.',
  'cfg.noProfiles': 'No profiles: copy config/example to config/<client>/ and fill in baseUrl + token.',
  'list.and': ' and ',
  'list.more': '{list} and {k} more',
  'type.text': 'text',
  'type.int': 'whole number',
  'type.dec': 'decimal number',
  'type.bool': 'yes/no',
  'type.date': 'date',
  'type.datetime': 'date and time',
  'type.dateAny': 'date',
  'glyph.text': 'Aa',
  'glyph.int': '12',
  'glyph.dec': '1.5',
  'glyph.bool': 'y/n',
  'glyph.date': 'd/m',
  'glyph.datetime': 'd/m h',
  'glyph.unsupported': '?',
  'sys.quest_id': 'the form code of the submission (e.g. {code})',
  'sys.response_id': 'the submission id',
  'sys.response_date': 'the submission date (yyyy-mm-dd hh:mm:ss)',
  'sysIn.quest_id': 'the form code',
  'sysIn.response_id': 'the submission id',
  'sysIn.response_date': 'the submission date',
  'sysCap.quest_id': 'The form code',
  'sysCap.response_id': 'The submission id',
  'sysCap.response_date': 'The submission date',
  'sysShort.quest_id': 'Submission form',
  'sysShort.response_id': 'Submission id',
  'sysShort.response_date': 'Submission date',
  'rc.none': 'No connections: the materialization never touches this field.',
  'rc.noSources': 'There are no active source forms: no submission reaches this field.',
  'rc.src.sys': 'Stores {sys}, which every submission carries.',
  'rc.src.a1.f1': 'Takes the value of the question {q} from the submissions of {form}.',
  'rc.src.a1.all': 'Takes the value of the question {q}, which all {n} source forms carry.',
  'rc.src.a1.one': 'Takes the value of the question {q}, which only {form} carries out of the {N} source forms.',
  'rc.src.a1.some': 'Takes the value of the question {q}, carried by {k} of the {N} source forms: {forms}.',
  'rc.src.aN': 'Takes the value of the first of these questions that the submission has answered: {chain}.',
  'rc.src.aN.all': 'All {n} source forms carry all of them.',
  'rc.src.partial': '{form} only carries {list}.',
  'rc.src.silent1': '{form} does not carry {what}: its submissions add nothing to this field.',
  'rc.src.silentN': '{forms} do not carry {what}: their submissions add nothing to this field.',
  'rc.what.a1': 'the question {q}',
  'rc.what.aN': 'any of these questions',
  'rc.src.dead': 'No active source form carries {what2}: the field will receive no values.',
  'rc.what2.aN': 'these questions',
  'rc.conv.text': 'The answer text is stored, without leading or trailing spaces; for a choice question, the option code. If it carries several answers, they are stored together: |a|b|.',
  'rc.conv.int': 'It is converted to a whole number: «12» or «12,0» are fine; «12,5» or text put the submission in error. Comma and dot are always decimal separators: «1.000» is stored as 1.',
  'rc.conv.dec': 'It is converted to a decimal number, with comma or dot («4,25» = «4.25»); text or a number with thousands separators («1.234,5») puts the submission in error.',
  'rc.conv.bool': 'It is read as yes/no: sí, si, s, yes, y, true or 1 mean yes; no, n, false or 0 mean no (case does not matter). Anything else puts the submission in error.',
  'rc.conv.date': 'It is converted to a date: dd/mm/yyyy or yyyy-mm-dd, with two digits for day and month; a time (hh:mm:ss), if any, is dropped. Any other format puts the submission in error.',
  'rc.conv.datetime': 'It is converted to date and time: dd/mm/yyyy hh:mm:ss, yyyy-mm-dd hh:mm:ss or yyyy-mm-ddThh:mm:ss; a date alone counts as 00:00. Any other format (for example, without seconds) puts the submission in error.',
  'rc.conv.dateAny': 'It is converted to a date: dd/mm/yyyy or yyyy-mm-dd, with two digits for day and month, optionally with the time including seconds (hh:mm:ss), which is kept only if the field stores it. Any other format puts the submission in error.',
  'rc.conv.unsupported': 'This field is of type {type}, which the materialization cannot convert: every submission that carries a value will end up in error.',
  'rc.conv.multi': 'If the question carries several answers at once, the submission ends up in error: a {type} field holds a single value.',
  'rc.conv.firstOnly': 'If the first answered question cannot be converted, the submission ends up in error: the next one is not tried.',
  'rc.conv.error': 'A submission in error writes nothing to the record (no field at all) and is retried with «Run now» or when the definition is saved again.',
  'rc.rule.last.f1': 'Last value: every submission with a value overwrites it; the most recent one stays.',
  'rc.rule.last.fN': 'Last value: every submission with a value overwrites it, whatever its form; the most recent one stays.',
  'rc.rule.first.f1': 'First value: it is only written when the field is empty; the value of the oldest submission that carried it stays.',
  'rc.rule.first.fN': 'First value: it is only written when the field is empty; the value of the oldest submission that carried it stays, whatever its form.',
  'rc.rule.first.existing': 'If the record already had a value (from another load or a manual edit), it is not changed.',
  'rc.rule.prio.fN': 'By priority: the highest-priority form wins ({ladder}). A submission with a value replaces it if its form has the same or higher priority than the one that set it (with equal priority, the most recent wins); a lower-priority one only writes it when the field is empty.',
  'rc.rule.prio.noEvidence': 'The form that set each value is recorded. If that is not on record (a value from before this rule was used, or set some other way), the first submission with a value replaces it, whatever its priority.',
  'rc.rule.prio.one': 'By priority: only {form} carries this field, so there is nobody to rank and it works like «Last value».',
  'rc.rule.prio.flat': 'By priority: the {n} forms that carry it share the same priority (P{p}), so it works like «Last value». Give them different priorities in Sources for it to decide.',
  'rc.ladder.one': 'P{p} {form}',
  'rc.ladder.many': 'P{p} ({n} forms)',
  'rc.rule.concat.f1': 'Concatenate: joins each distinct value in order of arrival, without repeating identical ones (case and accents count), always in the |a|b| format, even with a single value: |a|.',
  'rc.rule.concat.fN': 'Concatenate: joins the distinct values arriving from the {n} forms, in order of arrival and without repeating identical ones (case and accents count), always in the |a|b| format, even with a single value: |a|.',
  'rc.rule.concat.existing': 'A value the record already had is kept as the first item of the list.',
  'rc.mini.asLast': 'like «Last value»',
  'rc.miss.keep.a1': 'If the submission does not carry the question {q}, or it is blank, the field stays as it was.',
  'rc.miss.keep.aN': 'If the submission carries none of these questions, or they are blank, the field stays as it was.',
  'rc.miss.clear.a1': 'If the submission does not carry the question {q}, or it is blank, the field is cleared, whatever the rule.',
  'rc.miss.clear.aN': 'If the submission carries none of these questions, or they are blank, the field is cleared, whatever the rule.',
  'rc.miss.clear.last': 'This way the field always mirrors the latest submission, even when it comes without a value.',
  'rc.miss.never': 'Since {sys} comes with every submission, a value is never missing: «If the submission has no value» does not apply.',
  'rc.ext': 'It lives in {table}, a 1:1 extension of {root}: that record is only created when a submission brings a value for one of its fields.',
  'rc.key.id': 'Set by the key: it is the source id of each submission, taken from the question chosen in each source form. It takes no connections.',
  'rc.key.origin': 'Set by the key: it is the origin of each submission, taken from its form\'s origin question or, if it has none or it is blank, from its fixed text. It takes no connections.',
  'rc.key.match': 'Two submissions with the same origin and source id (ignoring case, accents and trailing spaces) update the same record; if it does not exist, it is created.',
  'rc.key.spelling': 'The record keeps the origin and id exactly as they come in the latest submission that updates it.',
  'rc.key.error': 'A submission without a source id, or without an origin, ends up in error and is not loaded.',
  'rc.key.q': 'question {q}',
  'rc.key.text': 'fixed text «{v}»',
  'rc.key.both': 'question {q}; if blank, «{v}»',
  'rc.key.none': 'not chosen: it cannot run',
  'w.dead': 'No active source form carries the question {q}: that connection adds nothing.',
  'w.clearSilent1': '{form} does not carry {what} and the field is set to «Clear»: each of its submissions will empty it.',
  'w.clearSilentN': '{forms} do not carry {what} and the field is set to «Clear»: each of their submissions will empty it.',
  'w.sysType': '{sysCap} is text and does not fit a {type} field: every submission will end up in error.',
  'w.sysTypeDate': 'The submission date does not fit a {type} field: every submission will end up in error.',
  'w.afterSys': '{sysCap} comes with every submission: the questions after it ({rest}) will never be used.',
  'w.concatNotText': '«Concatenate» only joins values in text fields: in this {type} field it works like «Last value».',
  'w.firstClear': 'With «Clear», a submission without a value empties the field and the next one with a value writes it again: the first value is no longer kept.',
  'w.prioClear': 'With «Clear», a submission without a value empties the field even if its form has lower priority; afterwards any form can fill it again.',
  'w.concatClear': 'With «Clear», a submission without a value wipes everything accumulated.',
  'rc.note.title': 'How submissions are processed',
  'rc.note.order': 'On each run, the pending submissions of all active source forms are processed together, from oldest to newest (by submission date and, for equal dates, by id).',
  'rc.note.noop': 'If the resulting value equals the current one, nothing is written.',
  'rc.note.lateRetry': 'A submission that failed and is retried later is applied after those already loaded, even if it is older.',
  'rc.note.reactivate': 'If the record was deleted and a submission arrives for it, it is restored.',
  'rc.note.past': 'Changes to rules and connections only apply to submissions not yet loaded: those already loaded are not revisited.',
  'rc.one': '{rule} · {from} · {cover} · no value: {miss}',
  'rc.one.noCover': '{rule} · {from} · no value: {miss}',
  'rc.from1': 'from {q}',
  'rc.from2': 'from {q} › {q2}',
  'rc.fromMore': 'from {q} › {q2} and {k} more',
  'rc.coverAll': 'all {N} forms',
  'rc.coverSome': '{k} of {N} forms',
  'rc.missKeep': 'kept',
  'rc.missClear': 'cleared',
  'rc.missNever': 'never happens',
  'chip.priority': 'priority',
  'chip.priorityLadder': 'priority {ladder}',
  'chip.concat': 'concatenates',
  'chip.clear': 'clears if empty',
  'chip.coverTitle': 'Carried by {k} of the {N} active source forms',
  'rc.pf.title': 'By form',
  'rc.pf.uses': 'uses {chain}',
  'rc.pf.silent': 'carries none',
  'rc.pf.keep': 'no value: keeps',
  'rc.pf.clear': 'no value: clears',
  'rc.pf.never': 'always has a value',
  'rc.pf.ignored': 'leaves it alone',
  'rc.pf.clearsAlways': 'clears it on every submission',
  'rc.pf.off': 'disabled: not processed',
  'rc.pf.missing': 'form not active: not processed',
  'rc.pf.leads': 'wins',
  'rc.pf.group': '{n} forms',
  'rc.pf.show': 'show',
  'ex.title': 'Example',
  'ex.hint': 'Made-up submissions in order of arrival: change values or forms to try it out.',
  'ex.start': 'The record starts',
  'ex.startNew': 'new (empty)',
  'ex.startHad': 'with a value from another load: {v}',
  'ex.result': 'Result: {v}',
  'ex.none': 'No form carries these questions: no example is possible.',
  'ex.yes': 'yes',
  'ex.no': 'no',
  'ex.fill': 'fills it (was empty)',
  'ex.set': 'overwrites it',
  'ex.same': 'same value: nothing written',
  'ex.sameEv': 'same value; now recorded as P{p}',
  'ex.ignoredFirst': 'already had a value: unchanged',
  'ex.prioWins': 'P{p} has equal or higher priority than P{q}: writes',
  'ex.ignoredPrio': 'P{p} has lower priority than P{q}: unchanged',
  'ex.noEvidence': 'no record of who set it: writes',
  'ex.concat': 'added to the list',
  'ex.concatDup': 'already in the list: unchanged',
  'ex.keep': 'no value: stays the same',
  'ex.clear': 'no value: cleared',
  'ex.error': '«{raw}» is not a valid {type}: the submission ends up in error and writes nothing',
  'ex.silent': '{form} does not carry these questions',
  'ex.matrix': 'And with another rule?',
  'ex.matrixHint': 'Final result with each rule; click a cell to apply it.',
  'ex.flag': 'this combination has a warning',
  'conv.ok': 'valid',
  'conv.bad': 'puts the submission in error',
  'conv.thousands': 'the dot is a decimal point, not thousands',
  'fs.g.A': 'Source',
  'fs.g.C': 'Conversion',
  'fs.g.R': 'Rule',
  'fs.g.M': 'No value',
  'fs.g.X': 'Record',
  'fs.g.K': 'Key',
  'chk.targets': 'Connections to valid entity fields',
  'when.chip': 'When: {v}',
  'when.once': 'once',
  'when.manual': 'manual',
  'when.cron': 'cron {v}',
  'def.change': 'Change…',
  'def.changeConfirm': 'Changing the entity removes the {n} connections and their rules. Continue?',
  'seg.last': 'Last',
  'seg.first': 'First',
  'seg.priority': 'Priority',
  'seg.concat': 'Concatenate',
  'seg.keep': 'Leave',
  'seg.clear': 'Clear',
  'missing.keep.d': 'If the submission has no value, it stays as it was.',
  'missing.clear.d': 'If the submission has no value, it is erased, whatever the rule.',
  'src.title': 'Sources',
  'src.add': '+ Add form',
  'src.addTitle': 'Add source form',
  'src.addOverlap': 'carries {k} of the {m} connected questions',
  'src.addNone': 'No active forms left to add.',
  'src.empty': 'No source forms. Add one: its questions will appear on the canvas so you can connect them to fields.',
  'src.coverage': '{k}/{m} connected',
  'src.coverageTitle': 'Carries {k} of the {m} questions connected in this definition',
  'src.missing': 'form not active: not processed',
  'src.off': 'disabled: not processed',
  'src.filter': 'filter forms…',
  'src.added': 'Form added: {form}.',
  'src.removed': 'Form removed: {form}.',
  'key.fixed': '«{v}» (fixed text)',
  'cv.aliases': 'Submission questions',
  'cv.aliasesSub': 'from the source forms',
  'cv.key': 'Key',
  'cv.keyVaries': 'varies by form ({n})',
  'cv.keyMissing': 'missing in {n}',
  'cv.count': '{n} connected',
  'cv.freeAliases': '{n} unconnected questions',
  'cv.freeFields': '{n} unconnected fields',
  'cv.sysGroup': 'Submission data',
  'cv.tagSys': 'data',
  'cv.search': 'Search field or question',
  'cv.matches': '{n} matches',
  'cv.onlyWarnings': 'Warnings only · {n}',
  'cv.legend': 'Legend',
  'cv.emptyHint': 'Drag a question\'s ● onto a field to connect them, or click a field and pick its question.',
  'cv.noSourcesHint': 'Add a source form to see its questions.',
  'cv.peekHint': 'Click to see and edit how it is computed',
  'cv.deadTitle': 'No active source form carries this question',
  'cv.orderTitle': 'Question {i}: used when the previous ones are not answered',
  'cv.aliasPeek': '{q} · {alias} · {k} of {N} carry it · connected to {fields}',
  'cv.legacy': '{name}: no longer an extension of {root}',
  'cv.legacyRemove': 'Remove its {n} connections',
  'zoom.fitWidth': 'Fit to width',
  'lg.on': 'A, B…: the form\'s letter in «Sources»; in colour, it carries it',
  'lg.off': 'in grey, it does not',
  'lg.dis': 'struck through, form disabled or not active',
  'lg.bar': 'with more than 8 forms: how many carry it',
  'lg.line': 'one line per connection',
  'lg.sys': 'dashed: submission data (always present)',
  'lg.dead': 'dotted amber: no active form carries it',
  'lg.order': '①②: preference order when a field has several questions',
  'lg.key': 'ID / ORIGIN: key question in some form',
  'lg.status': 'amber dot: warning · red: problem',
  'em.position': 'question {i} of {n} for this field',
  'em.only': 'only question for this field',
  'em.carried': 'Carried by {k} of {N} source forms',
  'em.global': 'The connection applies to every form that carries this question.',
  'em.rule': 'Field rule',
  'em.ruleAll': 'applies to its {n} questions',
  'em.ruleOne': 'applies to the whole field',
  'em.missing': 'No value',
  'em.up': 'Use earlier',
  'em.down': 'Use later',
  'em.first': 'Use it first',
  'em.replace': 'Change question…',
  'em.move': 'Move to another field…',
  'em.moveTitle': 'Move {q} to…',
  'em.copy': 'Also connect to…',
  'em.fallback': 'Add another question after it…',
  'em.forms': 'See which forms carry it',
  'em.formOn': 'carries it',
  'em.formOff': 'does not carry it',
  'em.open': 'Open the field',
  'em.remove': 'Remove connection',
  'em.back': 'Back',
  'fs.prev': 'Previous field (Alt+PageUp)',
  'fs.next': 'Next field (Alt+PageDown)',
  'fs.chain': 'Questions, in order of preference',
  'fs.chainHint': 'The first one the submission has answered is used.',
  'fs.add': '+ Add question…',
  'fs.suggested': 'Suggested',
  'fs.carried': '{k} of {N} carry it',
  'fs.up': 'Move up (Alt+↑)',
  'fs.down': 'Move down (Alt+↓)',
  'fs.change': 'Change question (Enter)',
  'fs.remove': 'Remove (Del)',
  'fs.missing': 'If the submission has no value',
  'fs.run': 'How it will run',
  'fs.column': 'column {c}',
  'fs.warnCount': '{n} warnings',
  'fs.keyTitle': 'KEY · {what}',
  'fs.removeAll': 'Remove its connections',
  'fs.revert': 'Undo field changes',
  'fs.done': 'Done',
  'fs.editSource': 'Edit in Sources',
  'pk.search': 'search…',
  'pk.none': 'No results',
  'pk.questions': 'Questions',
  'pk.used': 'connected to {fields}',
  'pk.here': 'already connected to this field',
  'pk.key': 'set by the key',
  'pk.current': 'current field',
  'ep.title': 'Which entity will you materialize?',
  'ep.hint': 'It is materialized with its 1:1 extensions. Only one materialization per entity.',
  'ep.fields': '{n} fields',
  'ep.key': 'key: {origin} + {id}',
  'ep.current': 'current',
  'ep.allTaken': 'Every materializable entity already has its materialization.',
  'ep.cancel': 'Cancel',
  'adv.title': 'Warnings · do not block running',
  'adv.count': '{n} warnings',
  'adv.in': 'in: {list}',
  'adv.dead': 'Questions no active form carries',
  'adv.sysType': 'Submission data in fields of another type (every submission will fail)',
  'adv.unsupported': 'Fields of a type that cannot be converted',
  'adv.clearSilent': '«Clear» on fields some form does not carry',
  'adv.concatNotText': '«Concatenate» on non-text fields',
  'adv.prioFlat': '«By priority» with forms of equal priority',
  'adv.afterSys': 'Questions after submission data (never used)',
  'adv.formMissing': 'Source forms no longer active (not processed)',
  'toast.undo': 'Undo',
  'toast.redo': 'Redo',
  'toast.open': 'Open the field',
  'toast.view': 'View',
  'toast.connected': 'Connected {q} → {field}.',
  'toast.removed': 'Connection removed.',
  'toast.removedAll': 'Removed {n} connections from {field}.',
  'toast.moved': 'Connection moved to {field}.',
  'toast.copied': 'Also connected to {field}.',
  'toast.exists': '{q} was already connected to {field}.',
  'toast.merged': '{q} was already connected to {field}: the duplicate was removed.',
  'toast.undone': 'Undone: {what}.',
  'toast.redone': 'Redone: {what}.',
  'toast.serverProblems': 'Saved. The server reports {n} problems.',
  'toast.entity': 'Entity changed to {name}.',
  'hist.connect': 'connect',
  'hist.remove': 'remove connection',
  'hist.removeAll': 'remove field connections',
  'hist.reorder': 'reorder',
  'hist.replace': 'change question',
  'hist.move': 'move connection',
  'hist.copy': 'also connect',
  'hist.fallback': 'add question',
  'hist.rule': 'change rule',
  'hist.addSource': 'add form',
  'hist.removeSource': 'remove form',
  'hist.source': 'change source form',
  'hist.entity': 'change entity',
  'hist.revert': 'undo field changes',
  'hist.legacy': 'remove old connections',
  'src.keyId': 'ID',
  'src.keyOrigin': 'ORIGIN',
  'when.every': 'every',
  'em.removeKey': 'Del',
  'fs.warnOne': '1 warning',
  'fs.missKeep.d': 'It stays as it was.',
  'fs.missClear.d': 'It is erased, whatever the rule.',
  'ex.formOf': 'Form of the {day} submission',
  'ex.valueOf': 'Value of the {day} submission',
  'src.keyEntity': 'ENTITY ID',
  'ins.keyMode': 'How the record is identified',
  'ins.keyMode.origin': 'Origin + source id',
  'ins.keyMode.entity': 'Entity ID',
  'ins.entityIdAlias': 'Question with the entity ID',
  'ins.entityKeyHint': 'The submission updates the entity with that ID. If the question is blank a new one is created; if it carries an ID that does not exist, the submission ends up in error.',
  'rc.key.byEntity': 'does not fill it: identifies the entity by its ID ({q})',
  'rc.key.entityNote': 'Forms that identify the entity by its ID leave origin and source id untouched: a new entity created that way leaves them empty.',
  'src.badge': 'Form {code}: its letter marks on the canvas the questions it carries',
  'src.prefix': 'PREFIX',
  'src.prefixTitle': 'Common prefix of this form\'s aliases: not repeated on the canvas',
  'cv.orphans': '⚠ Remove {n} connections without a form',
  'cv.orphansTitle': 'Questions that are in no form of the definition (never carry a value): {list}',
  'hist.orphans': 'remove connections without a form',
  'cv.aliasesOfForm': 'of form {code} · {name}',
  'cv.otherForms': 'Connected from another form (select it in «Sources» to see its lines)',
  'src.orderHint': 'Order is priority: drag the cards by their handle to change it.',
  'src.dragTitle': 'Drag to change the priority',
  'src.prioTitle': 'Priority {n} (position in the list)',
  'src.up': '↑ Move up',
  'src.down': '↓ Move down',
  'hist.moveSource': 'change priority',
  'src.expand': 'Show form details',
  'src.collapse': 'Hide details',
};

const messages = { es, ca, en };

export function t(key, params) {
  let s = (messages[locale.value] || es)[key] ?? es[key] ?? key;
  if (params) {
    for (const [k, v] of Object.entries(params)) s = s.split(`{${k}}`).join(String(v));
  }
  return s;
}
